// 客戶入口（網站端，web_include_js）。
//
// 1. 支援單（web form「issues」）：優先順序是 Issue Priority 的連結欄位，記錄名是英文。
//    網站端沒有 boot，web form 只載入七十幾條翻譯，連結欄位與列表都印記錄名「Medium」。
//    優先順序是我們分派用的，不讓客戶選（預設值照樣是中）；列表上已有的值換成中文。
//    不改 ERPNext 的標準 web form 記錄 —— 標準 web form 在非 developer mode 存不了，
//    升級時 migrate 會失敗（2026-09-24 lab 實測）。webform_include_js 只掛在表單頁、
//    列表頁沒有，所以用全站的 web_include_js，自己看網址。
// 2. 上游寫死英文的分頁標題（login.py 的 "Login"、web form 列表的 "Issue"）。
//    網站端的 __() 只有少數翻譯，這幾個直接寫中文。
(function () {
	const PRIORITY = { Low: "低", Medium: "中", High: "高", Urgent: "緊急" };
	const TITLES = { Login: "登入", Issue: "問題" };

	function translate_cells(root) {
		(root || document).querySelectorAll(".web-list-table td, .list-table td").forEach((td) => {
			const text = td.textContent.trim();
			if (PRIORITY[text]) td.textContent = PRIORITY[text];
		});
	}

	// web form 是在 frappe.ready 之後才建出欄位的，等它建好再藏
	function hide_priority(tries) {
		const form = frappe.web_form;
		if (form && form.fields_dict && form.fields_dict.priority) {
			form.set_df_property("priority", "hidden", 1);
		} else if (tries > 0) {
			setTimeout(() => hide_priority(tries - 1), 100);
		}
	}

	frappe.ready(() => {
		const parts = document.title.split(" - ");
		const last = parts[parts.length - 1];
		if (TITLES[last]) {
			parts[parts.length - 1] = TITLES[last];
			document.title = parts.join(" - ");
		}

		if (!/^\/issues(\/|$)/.test(window.location.pathname)) return;
		hide_priority(50);
		translate_cells();
		new MutationObserver(() => translate_cells()).observe(document.body, { childList: true, subtree: true });
	});
})();
